import type { SetStateAction } from 'react';

export function isSetStateFunction<T>(state: SetStateAction<T>): state is (prev: T) => T {
    return typeof state === 'function';
}
